module.exports = __webpack_public_path__ + "static/media/style-3.443e8e23.svg";